import { Base64 } from './base64';

export class DownloadHelper {
    public static downloadBase64(content: string, fileName?: string): void {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(Base64.toBlob(content), fileName);
        } else {
            const link = document.createElement('a');
            link.style.display = 'none';

            const url = URL.createObjectURL(Base64.toBlob(content));
            link.href = url;
            link.target = '_blank';
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(url);
            document.body.removeChild(link);
        }
    }
}
